export default __webpack_public_path__ + "static/media/segre03.24bd1ef0.jpg";